import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import Alert from 'shared/components/Alert.jsx';

const messages = defineMessages({
    successText: {
        id: 'join.fast.success.text',
        defaultMessage: 'Ваш счет успешно активирован!'
    },
    rechargeText: {
        id: 'join.fast.success.recharge_text',
        defaultMessage: 'Пополните баланс, чтобы начать игру'
    },
    btnRechargeText: {
        id: 'join.fast.success.btn_recharge_text',
        defaultMessage: 'Пополнить баланс'
    }
});

export default class extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        domain: React.PropTypes.string.isRequired,
        finalizeJoin: React.PropTypes.func.isRequired
    };

    constructor() {
        super();

        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick() {
        this.props.finalizeJoin();

        window.open(`//members.${this.props.domain}/balance/recharge`, 'Recharge',
            "toolbar=no, location=no, status=no,menubar=no,scrollbars=yes, resizable=yes, width=1366, height=650");
    }

    render() {
        const alertProps = {
            type: "wide",
            title: <FormattedMessage {...messages.successText}/>,
            message: <FormattedMessage {...messages.rechargeText}/>,
            btnText: <FormattedMessage {...messages.btnRechargeText} />,
            clickCallback: this._handleClick
        };

        return (<Alert {...alertProps}/>);
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/registration/fast/PhoneRegistrationSuccess.jsx